module.exports = __webpack_public_path__ + "img/male.f5ba68b5.png";